import React, { Component } from 'react'
import Question from './Question'
import Option from './Option'
import Timer from '../Timer/Timer';
import Results from '../Results/Results';
import logo from '../assets/img/logo.png';
import Loading from '../Loading';

function randomize(a, b) {
  return Math.random() - 0.5;
}

export default class Quiz extends Component {

  constructor() {
    super();
    this.state = {
      currentQuestion: 0,
      currentQuestionAnswered: false,
      totalQuestions: 10,
      userName: "",
      email: "",
      answers: [0],
      selected: [],
      gameOver: false,
      gameOverReason: "",
      score: 0,
      time: this.getInterval(),
      questionsLoaded: false,
      questions: [
        {
          text: "Ma fi ____ yen",
          options: [
            {
              value: 1,
              text: "Owo"
            },
            {
              value: 0,
              text: "Gbe bodi e"
            },
            {
              value: 0,
              text: "Gbe fun e"
            },
            {
              value: 0,
              text: "O wole"
            },
            {
              value: 0,
              text: "mi si"
            },
            {
              value: 0,
              text: "Sanwo"
            },

          ]
        },
      ],
      button: <button onClick={this.nextQuestion
      } className="btn btn-lg btn-secondary waves-effect waves-light" > Next < i className="fas fa-arrow-right" ></i ></button >,
    };
    this.myRef = React.createRef()
  }

  getInterval = () => (new Date()).getTime() + (.25 * 60000)

  componentDidMount() {

    console.log("Showing Questions")
    fetch("https://teni-the-billionaire.firebaseio.com/questions.json", {
      method: 'GET'
    })
      .then(res => res.json())
      .then(data => {
        console.log(data)
        let questions = data
        questions = Object.values(questions)
        questions.sort(randomize)
        let questionsLoaded = true
        let totalQuestions = questions.length
        this.setState({ questions, questionsLoaded, totalQuestions, error: "" })
      })
      .catch(error => this.setState({ error: "There was an error fetching questions. Please try again." }))
  }

  isCurrentQuestion = (question) => {
    return question === this.state.currentQuestion
  }

  checkQuestionsCompleted = () => {
    if (this.state.currentQuestion > this.state.totalQuestions) {
      this.endGame("You made it!")
    }
  }

  selectOption = (question, answer) => {
    let answers = this.state.answers
    answers[question] = answer
    let currentQuestion = this.state.currentQuestion + 1

    if (answer == 1) {
      this.setState(
        {
          answers,
          currentQuestion,
          time: this.getInterval()
        }, 
        this.checkQuestionsCompleted
      )
    }
    else {
      this.endGame('Your Answer was Wrong!')
    }
  }

  endGame = (gameOverReason) => {
    if (! this.state.gameOver) {
      // let timeLeft = (Date.parse(new Date(this.state.time)) - Date.parse(new Date())) / 1000
      console.log(gameOverReason)
      let score = this.state.answers.reduce((sum, element) => {
        return sum + element;
      })
      // score += timeLeft / 2
      score *= 1000
      this.setState({ gameOver: true, gameOverReason, score })
    }
  }

  scrollToMyRef = () => window.scrollTo(0, this.myRef.current.offsetTop)

  render() {
    const results = <Results reason={this.state.gameOverReason} victory={true} score={this.state.score} />
    const gamePlay = <section id="hero">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-12">
            <img className="img-fluid brain" src={ logo } alt="Big Daddy Mo!" />
          </div>
        </div>
        <div className="row" ref={this.myRef}>
          <div className="col-sm-12">
            {
              this.state.questions.map((question, questionKey) => {
                return (
                  <Question key={questionKey} show={this.isCurrentQuestion(questionKey)}>
                    <div className="col-12 text-center">
                      <h5 className="col-sm-12 text">
                        <b>
                          {question.text}
                        </b>
                      </h5>
                      <div className="row">
                      {
                        (question.options.sort(randomize)).map((option, optionKey) => {
                          return (
                            <div className="col-md-6 col-12">
                              <Option
                                key={optionKey}
                                label={optionKey}
                                onClick={this.selectOption}
                                question={questionKey}
                                answer={option.value}
                                value={option.text}
                              />
                            </div>
                          )
                        })
                      }
                      </div>
                    </div>
                  </Question>
                )
              })
            }

            <div className="text-center">
              {/* {this.state.button} */}
            </div>
          </div>
        </div>
      </div>
    </section> 

    return (
      <div>
        {
          this.state.questionsLoaded ? 
          this.state.gameOver ? results : gamePlay
          : <Loading />
        }
      </div>
    )
  }
}
